export enum FlowType {
    // Phone -> credit card trial (user has only entered phone before landing on checkout)
    PTCC = 'ptcc',
    // Premium Only
    PREMIUM = 'premium',
    // Dryish Jan
    DRYJAN2024 = 'dryjan2024',
    // Med first
    MED_FIRST = 'med_first',
    // Med first winback
    MED_FIRST_WINBACK = 'med_first_winback',
    // Med upsell winback
    MED_UPSELL_WINBACK = 'med_upsell_winback'
}
